import { setHypotheticalId } from '../apps/hypotheticals-app/state/hypothetical-id/hypothetical-id.actions';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import * as i0 from "@angular/core";
export class SelectedHypotheticalService extends SelectedFolderableService {
    constructor() {
        super(...arguments);
        this.RESOURCE_TYPE = FolderableType.HYPOTHETICAL;
        this.ITEM_ID_SLICE_KEY = 'hypotheticalId';
    }
    clearSelection() {
        super.clearSelection();
        this.store.dispatch(setHypotheticalId({ id: null }));
    }
}
SelectedHypotheticalService.ɵfac = /*@__PURE__*/ (() => { let ɵSelectedHypotheticalService_BaseFactory; return function SelectedHypotheticalService_Factory(__ngFactoryType__) { return (ɵSelectedHypotheticalService_BaseFactory || (ɵSelectedHypotheticalService_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedHypotheticalService)))(__ngFactoryType__ || SelectedHypotheticalService); }; })();
SelectedHypotheticalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedHypotheticalService, factory: SelectedHypotheticalService.ɵfac });
